import { setDefaults } from '@udecode/slate-plugins';
import linkElement from './element';
import deserializeLink from './deserialize';
import renderElementLink from './render';

const LinkPlugin = options => {
  const { link } = setDefaults(options, linkElement);

  return {
    renderElement: renderElementLink(options),
    deserialize: deserializeLink(options),
    inlineTypes: [link.type],
  };
};

export default LinkPlugin;
